function getBaseUrl() {
	//return 'http://192.168.0.40:5990'
	//return 'http://127.0.0.1:5000'
	return 'http://211.196.209.30:5000'
}

export function getUrl(command) {
    return getBaseUrl() + command
}



// WEBPACK FOOTER //
// ./src/utils/network.js